import { useTranslation } from 'react-i18next';
import {
  formatPlaybackRange,
  formatPlaybackTime,
} from '@lib/utils/dateTimeHelpers';
import CitationChip from './CitationChip';
import { CitationMoment } from './utils/citationPages';

type Props = {
  // Verified moments (by start) of one video chip.
  moments: CitationMoment[];
  onOpenMoment: (moment: CitationMoment) => void;
};

// Verified video moments rendered after an inline document chip: one chip per
// moment ("3:00–4:30", or "3:00" when the end is unknown), each opening the
// video there with the moment marked. The BE caps a chip at a handful of
// moments, so they all show inline.
function CitationTimeChips({ moments, onOpenMoment }: Props) {
  const { t } = useTranslation();
  return (
    <>
      {moments.map((moment) => (
        <CitationChip
          key={moment.startSeconds}
          label={formatPlaybackRange(moment.startSeconds, moment.endSeconds)}
          ariaLabel={t('ai-citation-open-moment', {
            time: formatPlaybackTime(moment.startSeconds),
          })}
          onClick={() => onOpenMoment(moment)}
        />
      ))}
    </>
  );
}

export default CitationTimeChips;
